import Http from "./Http";

const basePath = "/tracking-links";

export class TrackingLinksService extends Http {
  /**
   * Send tracking id after clicking in the tracking link
   * @param {string} tid
   */
  sendClick(tid) {
    return this.post(`${basePath}/${tid}/clicks`);
  }
}

TrackingLinksService.$displayName = "TrackingLinksService";

export default new TrackingLinksService();
